import React from "react";
import { createRoot } from "react-dom/client";
import DashboardPreview from "../components/DashboardPreview";
import NewCase from "../screens/NewCase/NewCase";
import CaseShow from "../screens/CaseShow/CaseShow";
import ComplaintLetter from "../screens/ComplaintLetter/ComplaintLetter";
import NextSteps from "../screens/NextSteps/NextSteps";
import FeedbackBoard from "../screens/Feedback/FeedbackBoard";
import "../lib/topbar";

const SCREENS = {
  dashboard: DashboardPreview,
  new_case: NewCase,
  case_show: CaseShow,
  complaint_letter: ComplaintLetter,
  next_steps: NextSteps,
  feedback_board: FeedbackBoard,
};

const mount = document.getElementById("trunfo-root");
if (mount) {
  const raw = mount.dataset.props;
  const props = raw ? JSON.parse(raw) : { screen: "dashboard" };
  const Screen = SCREENS[props.screen] ?? DashboardPreview;
  createRoot(mount).render(<Screen {...props} />);
}
